import Button, { ButtonTheme } from 'components/Form/Button'
import Modal from 'components/Modal'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import './ResetPasswordModal.scss'
import FormRow from '../../../components/Form/FormRow'
import FormColumn from '../../../components/Form/FormColumn'
import Input from '../../../components/Form/Input'

type Props = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  resetUrl?: string
}

const ResetPasswordModal: React.FC<Props> = ({ isOpen, setIsOpen, resetUrl }) => {
  const { t } = useTranslation()

  const Footer = () => {
    return (
      <div className='Modal__footer ResetPasswordModal__footer'>
        <Button
          disabled={!resetUrl}
          onClick={() => {
            resetUrl && navigator.clipboard.writeText(resetUrl)
          }}
        >
          {t('common.copyButton')}
        </Button>
        <Button
          theme={ButtonTheme.BLUE_OUTLINE}
          onClick={() => void setIsOpen(false)}
        >
          {t('common.back')}
        </Button>
      </div>
    )
  }

  return (
    <Modal
      classNameChildren={'ResetPasswordModal'}
      title={t('user.resetPassword.header')}
      isOpen={isOpen}
      onClose={setIsOpen}
      footer={Footer()}
      scrollable
    >
      <div className={'ResetPasswordContainer'}>
        <FormRow>
          <FormColumn>
            <Input
              id='email'
              title={t('user.resetPassword.description')}
              placeholder={t('user.resetPassword.placeholder')}
              value={resetUrl ?? 'n/o'}
              onChange={() => void {}}
              disabled
            />
          </FormColumn>
        </FormRow>
      </div>
    </Modal>
  )
}

export default ResetPasswordModal
